// Update contents object below
const contents = {
  header: 'AWS Intel', //update with your client name
  logoTooltip: {
    href: '', //where the logo click drives to
    copy: '' // tooltip content
  },
  hero: {
    background: 'image', //options: "image" or "video"
    logoPlacement: 'top', //options: "top" or "center"
    title: 'Changing the Face of Moviemaking',
    copy:
      'Taking Hollywood blockbusters and award-winning web series postproduction to the cloud, Company 3 found new ways to collaborate globally, increase workflow efficiency, and expand its roster of diverse movie-making talent.'
  },
  inlinePhotos: {
    size: 'bodyWidth', //options: "fullBleed" or "bodyWidth"
    contents: [
      {
        class: 'photo1',
        caption:
          'When the pandemic hit, employees and clients were unable to gather in person at Company 3’s offices, including this one in Santa Monica, CA. So it shifted the postproduction workflows to the AWS cloud. (Company 3)'
      },
      {
        class: 'photo2',
        caption:
          'When the pandemic hit, employees and clients were unable to gather in person at Company 3’s offices, including this one in Santa Monica, CA. So it shifted the postproduction workflows to the AWS cloud. (Company 3)'
      },
      { class: 'photo3', caption: 'Source: Motion Picture Association, 2022.' },
      {
        class: 'photo4',
        caption:
          'On Lord of the Rings: The Rings of Power, Company 3 colorist Skip Kimball was able to work from his home and collaborate with creatives, production managers, and in-house finishing editors worldwide. (Company 3)'
      },
      { class: 'photo5', caption: 'caption' },
      { class: 'photo6', caption: 'caption' },
      { class: 'photo7', caption: 'caption' },
      { class: 'photo8', caption: 'caption' }
    ] //add more objects in the array if you have more than one photo
  },
  ctaTooltip: {
    href:
      'https://aws.amazon.com/intel/?trk=f6bd17c4-c501-434f-803e-c053fd06cfb9&sc_channel=display%20ads?utm_source=cnn&utm_medium=hyperlink&utm_campaign=gc-ngitl&utm_content=article4&utm_creative=link',
    copy: '' //tooltip content
  },
  pullQuoteContent: {
    pullQuote1:
      'Players who achieve extremely high scores in the app sometimes even get a chance to connect with a professional sports club for a tryout. “We’ve actually had a player who has done drills and had a call from the club on the same day. It’s happened that quickly,” says Richard Felton-Thomas, Director of Sport Science and COO at AiSCOUT. “It’s incredibly rewarding when a player gets signed who might never have been seen otherwise. It’s heartwarming, and it’s also a validation for the ability of this technology to change someone’s life.”',
    pullQuote2:
      'In fact, the program was such a huge success that India announced that it would make the Co-WIN platform open source so that all countries could save lives and protect health with a modern, cloud-based vaccine registration platform.'
  }
};

export default contents;
